import Text from "@components/atoms/Text";
import { ResultRowProps } from "./ResultRow.types";
import styles from "./ResultRow.module.scss";

export const ResultRow = ({
  label,
  value,
  wrapperClassName = "",
  labelClassName = "",
  valueClassName = "",
}: ResultRowProps) => (
  <div className={`${styles.resultRowWrapper} ${wrapperClassName}`}>
    <Text className={`${styles.labelText} ${labelClassName}`}>{label}</Text>
    <Text className={`${styles.valueText} ${valueClassName}`}>
      ₹{value?.toLocaleString() ?? 0}
    </Text>
  </div>
);
